/** タッチ端末（スマホ・タブレット）向けプレイ。ポインタロックの代わりに使う。 */
export const TOUCH_PLAY_MEDIA = '(hover: none) and (pointer: coarse)';

/** スティック半径に対する無入力の割合 */
export const STICK_DEADZONE = 0.18;

export function prefersTouchPlay(
  query: (media: string) => { matches: boolean } = (media) => window.matchMedia(media)
): boolean {
  if (typeof window !== 'undefined') {
    const override = new URLSearchParams(window.location.search).get('touch');
    if (override === '1') return true;
    if (override === '0') return false;
  }
  return query(TOUCH_PLAY_MEDIA).matches;
}

/** スティック中心からのオフセットを -1..1 の前後左右にする */
export function stickIntentFromOffset(
  dx: number,
  dy: number,
  radius: number,
  deadzone = STICK_DEADZONE
): { forward: number; strafe: number; knobX: number; knobY: number } {
  const reach = Math.max(1, radius);
  const length = Math.hypot(dx, dy);
  const clamp = length > reach ? reach / length : 1;
  const knobX = dx * clamp;
  const knobY = dy * clamp;
  const dead = deadzone * reach;
  if (length <= dead) {
    return { forward: 0, strafe: 0, knobX, knobY };
  }
  const analog = Math.min(1, (length - dead) / (reach - dead));
  const nx = dx / length;
  const ny = dy / length;
  return {
    forward: -ny * analog,
    strafe: nx * analog,
    knobX,
    knobY,
  };
}
